module.exports = __webpack_public_path__ + "img/PN.df59bdb0.svg";